import { render, staticRenderFns } from "./Prefunding.vue?vue&type=template&id=62b98492&scoped=true&"
import script from "./Prefunding.vue?vue&type=script&lang=js&"
export * from "./Prefunding.vue?vue&type=script&lang=js&"
import style0 from "./Prefunding.vue?vue&type=style&index=0&id=62b98492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b98492",
  null
  
)

export default component.exports